/*
We report play times to Kantar for them to report on combined
play time across VoD and broadcast services.
The Kantar SpringStreams library takes an Adapter (defined in
/Player-Web/players/vod/js/vod-player/index.js around line 470) which reports
the current play time and duration of the video being played.
It polls the position every 200ms, and if it detects that the
player has paused/seeked will record a new pst.
These are then reported by the library at regular intervals
as a call made using the format defined under 'data transport' on this page:
https://kantarmedia.atlassian.net/wiki/spaces/public/pages/159726832/Implementation+of+Stream+Measurement+for+BARB+TV+Player+Report#ImplementationofStreamMeasurementforBARBTVPlayerReport-DataTransport

Note that we should only report pst changes while in content playback,
while in ads the content is effectively paused from Kantar's perspective
(so each break causes a pst to be recorded).
*/
import PLAYER_VERSION from '../../../utils/version'

export default function kantarAnalytics(suppliedParams) {
  if (!window.SpringStreams) {
    // Only proceed if SpringStreamsLib lib has been loaded in window
    console.log('Unable to find SpringStreams library for Kantar Analytics.') // eslint-disable-line no-console
    return false
  }
  const params = processParams(suppliedParams)
  const sensors = new window.SpringStreams(params.sitename)
  return startTracking(params, sensors)
}

export function processParams(suppliedParams) {
  // define params here with some default values
  const params = {
    sitename: window.parent.STV.environment === 'production'
      ? 'stvdotcom'
      : 'stvdotcomtest',
    contentId: 'not_set',
    stream: 'od',
    player: 'STV Player VOD - Brightcove (HTML5)',
    playerVersion: PLAYER_VERSION,
    adapter: {},
    ...suppliedParams, // overwrite default params with suppliedParams argument
  }
  // Initialise SpringStreams sensors Attach meta data to adapter
  params.adapter.getMeta = () => ({
    pl: params.player,
    plv: params.playerVersion,
  })
  // define an ID for this tracker
  params.trackingId = `${params.sitename}/${params.stream}`
  // Send the measurement to Kantar
  params.desc = {
    stream: params.stream,
    duration: params
      .adapter
      .getDuration(), // this should be in seconds NOT mm:ss
    cq: params.contentId,
  }
  return params
}

export function startTracking(params, sensors) {
  sensors.track(params.trackingId, params.desc, params.adapter)
  sensors.debug = function kantarDebugSensors(data) { // eslint-disable-line no-param-reassign
    window.kantarStatus = data
    if (window.parent.STV.environment !== 'production') console.log(data) // eslint-disable-line no-console
  }

  window.addEventListener('beforeunload', sensors.unload)
  return sensors
}
